import React, { useState, useEffect, useRef } from "react";
import {
    DashboardOutlined,
    HomeOutlined,
    MenuUnfoldOutlined,
    MoneyCollectOutlined,
    PicRightOutlined,
    FileDoneOutlined, MenuOutlined, AuditOutlined,

} from "@ant-design/icons";
import { Button, Layout, Menu, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import './Customheader.css'; // Ensure this file includes the updated CSS
import { useAuth } from "../Auth/AuthProvider";

const { Sider } = Layout;
const { Title } = Typography;

function CustomSidebar({ buttonClicked }) {
    const [sidebarVisible, setSidebarVisible] = useState(buttonClicked);
    const [sidebarHidden, setSidebarHidden] = useState(false); // Track sidebar visibility
    // Track scroll state for shading effect
    const sidebarRef = useRef(null);


    // Ref for the sidebar

    const [sidebarOpen, setSidebarOpen] = useState(true); // Sidebar starts open

    // Toggle the sidebar (open/close) and adjust the width accordingly
    const toggleSidebar = () => {
        setSidebarOpen((prevState) => !prevState); // Toggle between open and closed
    };

    // Calculate the sidebar width based on the open state
    const sidebarWidth = sidebarOpen ? 200 : 50;

    useEffect(() => {
        setSidebarVisible(buttonClicked);
    }, [buttonClicked]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setSidebarVisible(false); // Hide sidebar when clicking outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // const handleButtonClick = () => {
    //     setSidebarVisible(!sidebarVisible);
    //     setSidebarHidden(false); // Show sidebar when the button is clicked
    //     setButtonHidden(false);  // Show button when clicked
    //     setButtonScrolled(false); // Remove shading when clicked
    // };

    const menuItems = [
        {
            key: "1",
            label: "Home",
            icon: <HomeOutlined style={{ color: '#6366f1' }} />,
            link: "home",
            permission: [],
        },
        {
            key: "4",
            label: "Reports",
            icon: <MenuUnfoldOutlined style={{ color: '#8B5CF6' }} />,
            permission: [],
            children: [
                {
                    key: "6",
                    label: "Loans",
                    icon: <MoneyCollectOutlined style={{ color: '#EC4899' }} />,
                    link: "reports/loans",
                    permission: ["productWiseLoanSummary",
                        "loanSummaryReportPDF",
                        "loanSummaryForDay",
                        "districtWiseLoanReport",
                        "districtLoanReport",
                        "productAndDistrictWiseLoanReport",
                        "loanTrailBalance",
                        "loanSummaryExcel",
                        "amountWiseLoanDisposeSummary",
                        "districtWiseLoanDisposeSummary",
                        "loanDisbursementAmount",
                        "loanPendingInstallment",
                        "loanCertificate",
                        "loanPaymentHistory",
                        "districtWiseDisposeSummary"],
                },
                {
                    key: "9",
                    label: "Deposits",
                    icon: <DashboardOutlined style={{ color: '#108981' }} />,
                    link: "reports/deposits",
                    permission: ["accountListView",
                        "closedAccountListView",
                        "depositSummary",
                        "branchDepositReport",
                        "summaryDepositsActiveAndDormant",
                        "dormantAccountBranch",
                        "districtAndIslandDepositSummary",
                        "districtWiseOtherDeposits",
                        "productWiseDepositReport",
                        "OtherAccountDistrictWise",
                        "accountTrailBalance",
                        "accountTrailBalanceWasamWise",
                        "activeAndDormantBackDateReport",
                        "cdPd",
                        "monthlyProductWiseDormantReport",
                        "accountDetails",
                        "fieldCollectionReport",
                        "accountCertificate",
                        "financialProductWiseSummary",
                        "shareAndMemberSummaryExcel",
                        "depositSummaryExcel",
                        "otherDepositsSummaryExcel",
                        "fieldCollectionReportExcel"],
                },
                {
                    key: "7",
                    label: "General",
                    icon: <PicRightOutlined style={{ color: '#F59608' }} />,
                    link: "reports/general",
                    permission: ["districtWiseLoanAndDepositCount",
                        "socialBenefitsAccountReport",
                        "investmentSummaryReport",
                        "districtWiseLoanAndDepositCount",
                        "commonDistributionExcel",
                        "investmentSummaryReport",
                        "investmentReviewReport",
                        "investmentTrailBalance",
                        "incomeReportSummaryPDF",
                        "statementReportSummaryPDF",
                        "accountBalanceCheckCertificate",
                        "loanBalanceCheckCertificate",
                        "dailyWorkDetails",
                        "dailyTransaction",
                        "commonDistributionExcel",
                        "statementReportSummaryExcel",
                        "incomeReportSummaryExcel",
                        "customerDetailsReport"],
                },
                {
                    key: "10",
                    label: "General Ledger",
                    icon: <FileDoneOutlined style={{ color: '#3862F6' }} />,
                    link: "reports/general-ledger",
                    permission: ["acoountGeneralLedger",
                        "ledgerReportByLedgerCode",
                        "generalLedgerTrailBalance",
                        "generalLedgerBranchWiseOpeningBalance"],
                },
                {
                    key: "11",
                    label: "Audit",
                    icon: <AuditOutlined style={{ color: '#f51515ff' }} />,
                    link: "/master/reports/audit",
                    permission: [
                        "transactionBalanceAuditReport",
                        "customerRegistrationAuditReport",
                        "loanDisposeAuditReport",
                        "groupDepositAuditReport",
                        "loanValueIssuedAuditReport",
                        "compulsoryBalanceAnalysis"],
                },
            ]
        },
    ];

    const location = useLocation().pathname;
    const navigate = useNavigate();

    const { loading, tokenExpired, permissions } = useAuth();


    const [current, setCurrent] = useState("");

    useEffect(() => {
        if (location.includes("reports")) {
            setCurrent("4");
        }
    }, [location]);

    const menuOnClickHandler = ({ item, key }) => {
        const selectedItem = menuItems.find(item => item.key === key) ||
            menuItems.flatMap(item => item.children || []).find(child => child.key === key);
        if (selectedItem) {

            navigate(selectedItem.link);
            setSidebarVisible(false);
        }
        setCurrent(key);
    };

    let menuItemWithPermission = [];

    function filterMenuItems(menuItems, userPermissions) {
        return menuItems
            .map(menu => {
                const menuPerms = menu.permission || [];

                // TRUE if user has at least one permission
                const hasPermission =
                    menuPerms.length === 0 ||
                    userPermissions.some(p => menuPerms.includes(p));

                // Filter children recursively
                let filteredChildren = [];
                if (menu.children) {
                    filteredChildren = filterMenuItems(menu.children, userPermissions);
                }

                if (hasPermission || filteredChildren.length > 0) {
                    return {
                        ...menu,
                        children: filteredChildren.length > 0 ? filteredChildren : undefined,
                    };
                }

                return null;
            })
            .filter(Boolean);
    }


    menuItemWithPermission = filterMenuItems(menuItems, permissions);

    return (
        // <div className={`custom-sidebar ${sidebarHidden ? 'hide-sidebar' : ''}`} ref={sidebarRef}>

        <Sider width={sidebarWidth}

            trigger={null}

            style={{
                backgroundColor: ' #001529',
                height: 'calc(85vh)', // Full viewport height minus header height

                overflow: 'hidden', // Prevent scrolling within the sidebar

                left: 0,

            }}
        >
            <div className="sidebar-toggler" onClick={toggleSidebar} style={{ cursor: 'pointer' }}>
                <MenuOutlined style={{ fontSize: '20px', color: '#6366f1' }} />
            </div>
            {sidebarOpen && (<div className="sidebar-container">
                <Menu
                    className="custom-menu"
                    mode="inline"
                    selectedKeys={[current]}
                    items={menuItemWithPermission}
                    onClick={menuOnClickHandler}
                    style={{ fontWeight: "bold", color: "grey" }}
                />
            </div>)}
        </Sider>
        // </div>
    );
}

export default CustomSidebar;
